<template>
  <div class="bg" style="color:var(--regpwd-primarytextcolor)">
    <spinner :spinnerOn="loading"></spinner>
    <img src="" class="splash hiddden" alt="">
    <div id="userRegistration" style="display:none;box-shadow: 2px 2px 10px #ccc;">
      <!--header>  </header -->
      <div style="max-width: 800px;margin: auto;padding-top:35px; padding:50px;background: #fff" v-if="tokenInvalid && !enableRefIdApproach">
        <div style="padding:10px;">
          <div style="background:#e34843;width:22px; height:auto;display: inline-block;margin-right: 10px;">
	          <span class="exclamatory-error-icon">!</span>
          </div>{{user_lang.tokenNotValid}}
        </div>
	      <div style="padding:10px;">{{user_lang.tokenInvalidInfo}}</div>
	      <!--div style="padding:10px;"><button>{{user_lang.reqNewToken}}</button></div-->
      </div>
      <div style="max-width: 800px;margin: auto;padding-top:35px; padding:50px;background: #fff" v-show="enableRefIdApproach && !tokenInvalid">
        <div style="padding:10px;"><!--div style="background:#e34843;width:22px; height:auto;display: inline-block;margin-right: 10px;">
	        <span class="exclamatory-error-icon">!</span></div-->{{user_lang.copyrefid}}</div>
	      <div style="padding:10px;"><input type="text" v-model="refId" /></div>
	      <div style="padding:10px;"><button @click="getTokenAndRedirect(refId)" style="color:#fff">Recover</button></div>
      </div>
      <div class="container-fluid" style="background:#fff" v-show="!tokenInvalid && !enableRefIdApproach">
        <div class="title-bar">
	        <p class="welcome" style="background:var(--regpwd-topnavbarbg);text-align:center;padding:15px;margin: 0px;">
            <span style="color: var(--regpwd-secondarytextcolor);font-size: 15px;font-weight: bold;">{{user_lang.hello}} {{firstName}}</span>&nbsp;
            <span style="color: var(--regpwd-secondarytextcolor);font-size: 15px;font-weight: bold;">{{user_lang.welcome_cargill}} {{brand}}</span>
          </p>
	      </div>
        <!--h1>{{user_lang.user_reg}}</h1-->
        <div class="row" v-show="!passwordreset && !accountunlocked">
  	      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="background: #fff;">
	          <!--div class="card-header" style="background: #040404;color: #fff;">{{user_lang.resetpwd}}</div-->
	          <div style="max-width: 800px;margin: auto;">
	            <div class="setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12">
	              <div style="color:#a7a7a7;margin-top: 10px;" v-show="codeSent">{{user_lang.enter_code_rule}}</div>
		            <div v-show="codeSent" id="smsPhoneCodeForm.edit.form" class="m-form verify-code-form clearfix leave-open-on-success" style="padding: 0px 15px; margin: 0px -15px;">
                  <input type="hidden" class="hide" name="_xsrfToken" value="bd39219af46c391c0ea3df7053f999588ed2ca5a8553eaf83a32d4d3f063915f">
                  <input type="hidden" name="smsFactor" value="true">
                  <input name="activateFactor" value="false" type="hidden" class="hide">
                  <label id="smsPhoneCodeForm.code.label" for="verifyCode" class="margin-btm-0" path="token" csserrorclass="error" style="display: block;margin-top:20px;">{{user_lang.enter_code}}</label>
			            <div class="">
			              <div class="">
			                <input v-model="verifycode" id="verifyCode" name="code" class="verify-code" type="text" value="" autocomplete="off"
  			                style="visibility: inherit;position: inherit;width:100%;display: inline-block !important;display: inline-block !important;padding-top: 0px;">
	  		            </div>
		  	            <div style="margin-bottom:10px;float:right">
			                <input style="visibility: inherit;position: inherit;color: var(--regpwd-secondarytextcolor);border: 1px solid rgb(195, 195, 195);
			                  display: inline-block !important;    font-size: 13px;border-radius:3px;margin-bottom:20px;max-width: 120px;padding: 8px 16px;"
			                  v-bind:value="user_lang.verify" name="m-save" type="button" id="smsPhoneCodeForm.button.submit" class="ajax-form-submit verify-code save button" @click = "verifyResendCode()">
			                <button v-show="codeSent" class="" style="background:#f9f9f9;color:var(--regpwd-secondarytextcolor);
  			                border:1px solid #c3c3c3;font-size:13px;display: inline-block !important; margin-top: 6px;height: 35px;line-height: 14px;max-width: 120px;
	  		                margin-bottom: 10px;" @click="forgotSQA()">{{user_lang.back}}</button>
			                <button v-show="codeSent" class="" style="background:#f9f9f9;color:var(--regpwd-secondarytextcolor);
			                  border:1px solid #c3c3c3;font-size:13px;display: inline-block !important; margin-top: 6px;height: 35px;line-height: 14px;max-width: 120px;
			                  margin-bottom: 10px;" @click="goBack()">{{user_lang.retry}}</button>
			              </div>
			            </div>
                  <div id="smsPhoneCodeForm.edit.errors" style="" class="" v-show="iserror">
                    <div style="padding:10px;">
                      <div style="background:#e34843;width:22px; height:auto;display: inline-block;margin-right: 10px;">
                        <span class="exclamatory-error-icon">!</span>
                      </div>{{user_lang.passcodeNotValid}}
                    </div>
                  </div>
                  <div style="padding:10px;" v-show = "error30SecOTP == true">
                    <div style="background:#e34843;width:22px; height:auto;display: inline-block;margin-right: 10px;">
                      <span class="exclamatory-error-icon">!</span>
                    </div>{{user_lang.OTPEnableAfter30Sec}}
                  </div>
                  <div style="padding:10px;" v-show = "emptypasscode == true">
                    <div style="background:#e34843;width:22px; height:auto;display: inline-block;margin-right: 10px;">
                      <span class="exclamatory-error-icon">!</span>
                    </div>{{user_lang.emptypasscode}}
                  </div>
                </div>
              </div>
              <div class="setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 20px;margin-top: 10px;" v-show="showResetQA && !codeSent">
                <div class="row" style="padding-top: 0px">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin: auto;text-align: left;">
                    <span>{{user_lang.choose_forgot_pwd_qtn}}</span>
                    <select v-model="selectedSecQN" style="width:100%;">
                      <optgroup v-bind:label="user_lang.stock_qtn">
                        <option v-for="sq in listofsecquestions" v-bind:value="sq.question">{{sq.questionText}}</option>
                      </optgroup>
                      <optgroup v-bind:label="user_lang.custom_qtn">
                        <option value="custom">{{user_lang.own_sec_qtn}}</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div class="row" style="padding-top: 0px" v-show="selectedSecQN == 'custom'">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin: auto;text-align: left;">
                    <span>{{user_lang.custom_qtn}}</span>
                    <input v-model="custom_question" style="width:100%;" />
                  </div>
                </div>
                <div class="row" style="padding-top: 0px">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin: auto;text-align: left;">
                    <span>{{user_lang.answer}}</span>
                    <input v-model="answer" style="width:100%;" />
                  </div>
                </div>
                <div class="row" style="padding-top: 15px">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin: auto;text-align: left;">
                    <span>{{user_lang.enter_new_pwd}}</span>
                    <input  v-bind:placeholder = "user_lang.newpwd" type="password" v-model="password" style="width:100%;" />
                    <!--span class="password-rule">{{user_lang.pwd_rule}}</span-->
                  </div>
                </div>
                <div class="errorwrapper">
                  <span class="pwderror" v-for="i in pwdValidationObj">{{i}}</span>
                </div>
                <div class="row" style="padding-top: 0px">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin: auto;text-align: left;">
                    <span>{{user_lang.repeat_pwd}}</span>
                    <input v-bind:placeholder = "user_lang.rptpwd" type="password" v-model="repeatpassword" style="width:100%;" />
                  </div>
                </div>
                <div class="errorwrapper">
                  <span class="pwderror" v-for="j in repeatPwdValidationObj">{{j}}</span>
                </div>
                <div class="" style="display:flex;margin-left: auto;margin-right: auto;text-align: left; padding-top: 0px;background: #d2d2d2; margin-top: 15px !important;" v-show="errorCode != ''">
                  <div style="background:#e34843;width:22px; height:auto;">
                    <span class="exclamatory-error-icon">!</span>
                  </div>
                  <div style="color:#333;margin-left:20px;" >{{user_lang[errorCode]}}</div>
                </div>
                <div class="setup-section">
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="">
                      <button class="btn-primary create-acc" v-bind:value="user_lang.create_acc" @click="resetPassword()">{{user_lang.resetSecQA}}
                        <i class="fa fa-chevron-right"  style="color: var(--regpwd-secondarytextcolor);padding-left: 10px;"></i></button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Commented for removing Security Question in Okta -->
              <!--div class="setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12" v-show="!secQAVerified && !loading && !codeSent && !showResetQA">
                <div class="row" style="padding-top: 15px">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin: auto;text-align: left;">
                    <span style="font-weight:bold">{{user_lang.ansForgotten}}</span>
                    <div class="">{{userSecQuestion}}</div>
                  </div>
                </div>
                <div class="row" style="padding-top: 0px;">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin: auto;text-align: left;">
                    <input v-bind:placeholder = "user_lang.answer" type="text" v-model="answer" style="width:100%;" />
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="display:flex;margin-left: auto;margin-right: auto;text-align: left; padding-top: 0px;background: #d2d2d2;margin-top: 15px !important;" v-show="errorCode != ''">
                    <div style="background:#e34843;width:22px; height:auto;">
                      <span class="exclamatory-error-icon">!</span>
                    </div>
                    <div style="color:#333;margin-left:20px;" >{{user_lang[errorCode]}}</div>
                  </div>
                </div>
                <div class="row" v-if="recoveryType !== 'UNLOCK'">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="">
                    <span class="forgot-link" @click = "forgotSQA()">{{user_lang.forgotSQA}}</span>
                  </div>		  
                  <div style="padding:10px;padding-bottom:0px;" v-show="nofactorpresent == true">
                    <div style="background:#e34843;width:22px; height:auto;display: inline-block;margin-right: 10px;float: left;">
                      <span class="exclamatory-error-icon">!</span>
                    </div>{{user_lang.nofactorpresent}}
                  </div>
                </div>
                <div class="">
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="">
                      <button class="btn-primary create-acc" @click="resetPasswordCheckSecQA()"> {{recoveryType !== 'UNLOCK' ? user_lang.resetpwd : user_lang.unlockaccount}}<i class="fa fa-chevron-right" style="color: var(--regpwd-secondarytextcolor);padding-left: 10px;"></i></button>
                    </div>
                  </div>
                </div>
              </div-->
              <div class="setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12" v-show="secQAVerified">
                <div class="row" style="padding-top: 15px">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin: auto;text-align: left;">
                    <div style="font-weight:bold">{{user_lang.resetOktaPwd}}</div>
                    <span>{{user_lang.enter_new_pwd}}</span>
                    <input  v-bind:placeholder = "user_lang.newpwd" type="password" v-model="password" style="width:100%;" />
                    <!--span class="password-rule">{{user_lang.pwd_rule}}</span-->
                  </div>
                </div>
                <div class="errorwrapper">
                  <span class="pwderror" v-for="i in pwdValidationObj">{{i}}</span>
                </div>
                <div class="row" style="padding-top: 0px">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin: auto;text-align: left;">
                    <span>{{user_lang.repeat_pwd}}</span>
                    <input v-bind:placeholder = "user_lang.rptpwd" type="password" v-model="repeatpassword" style="width:100%;" />
                  </div>
                </div>
                <div class="errorwrapper">
                  <span class="pwderror" v-for="j in repeatPwdValidationObj">{{j}}</span>
                </div>
                <div class="" style="display:flex;margin-left: auto;margin-right: auto;text-align: left; padding-top: 0px;background: #d2d2d2; margin-top: 15px !important;" v-show="errorCode != ''">
                  <div style="background:#e34843;width:22px; height:auto;">
                    <span class="exclamatory-error-icon">!</span>
                  </div>
                  <div style="color:#333;margin-left:20px;" >{{user_lang[errorCode]}}</div>
                </div>
                <div class="setup-section">
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="">
                      <button class="btn-primary create-acc" v-bind:value="user_lang.create_acc" @click="resetPasswordWithoutQAReset()">
                        {{user_lang.resetpwd}}<i class="fa fa-chevron-right" style="color: var(--regpwd-secondarytextcolor);padding-left: 10px;"></i></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="congrats" v-show="passwordreset">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="background: #fff;">
            <div  style="max-width: 800px;margin: auto;">
              <div class="setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div style="font-size: 22px; width:80%;display: inline-block;margin-bottom: 10px;margin-top: 5px;">{{user_lang.passwordreset}}
                  <div style="font-size: 16px;">{{user_lang.passwordresetsuccess}}</div>
                </div>
                <div style="display: inline-block;width:20%;float: right;"><i class="fa fa-check-circle" style=" font-size:50px; color: var(--theme-primary) "></i></div>
                <div style="font-size: 16px; width:80%;display: inline-block;margin-bottom: 10px;" v-show="regApps.length !== 0">
                  {{user_lang.gotoapp}}
                </div>
                <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6 regapps" v-for="i in regApps"
                  @click = "goToApp(i.name.toLowerCase() === 'bookmark' ? i.settings.app.url : i._links.appLinks[0].href)" v-bind:title = "i.label">
                  <div  class="icon-wrap">
                    <img v-bind:src="i._links.logo[0].href" style="max-width: 90px;"/>
                  </div>
                  <div style="">{{i.label}}</div>
                </div>
              </div>
            </div>
          </div>
          <!--div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="">
            <button class="btn-primary create-acc"
              v-bind:value="user_lang.getstarted" @click="handleRedirect()">{{user_lang.getstarted}}<i class="fa fa-chevron-right"  style="color: #fff;padding-left: 10px;"></i></button>
            <div style="clear: both;"></div>
          </div-->
        </div>
        <div id="unlocked" v-show="accountunlocked">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="background: #fff;">
            <div  style="max-width: 800px;margin: auto;">
              <div class="setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div style="font-size: 22px; width:80%;display: inline-block;margin-bottom: 10px;margin-top: 5px;">{{user_lang.accountunlocked}}
                  <div style="font-size: 16px;">{{user_lang.unlockaccountsuccess}}</div>
                </div>		
                <div style="display: inline-block;width:20%;float: right;"><i class="fa fa-check-circle" style=" font-size:50px; color: var(--theme-primary) "></i></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  // import base64 from 'base-64'
  import storage from '../helpers/storage';
  import Spinner from '@/components/Spinner'
  import { locale } from '@/i18n/locale.js'
  import { EventBus } from '@/event-bus.js';
  import idmApi from '@/idm-api'
  const islowerCase = '^(?=.*[a-z])'
  const isUpperCase = '^(?=.*[A-Z])'
  const isNumber = '^(?=.*[0-9])'
  const isSpecialChar = '^(?=.*[!@#$%^&*-])'
  const isMinLength = '^(?=.{8,})'
  const apiUrl = process.env.API_URL;
  const internalUserDomains = require('../internalUserEmailDomains.json').data;
  // const onecargillappid = process.env.KEY_ID;
  // import okta from '@/helpers/okta'
  const brandDetails = require('../brand-details.json');
  export default {
    created () {
      this.fetchTokenAndInitiate()
      var self = this
      $(document).on('keypress', 'input', function() {
        self.errorCode = ''
      });
      $(document).on('keypress', '#phoneNumber,#verifyCode', function(evt) {
        self.keyPressHandler(evt)
      })
      // check user language and assign corresponding label object
      // this.user_lang = this.lang_br // lang_br for br portuguese
      setTimeout(self.assignUserLang(), 1000) // lang_br for br portuguese
      EventBus.$on('lang', function (language) {
        self.user_lang = self.lang_obj[language]
        self.lang = language
      })
    },
    mounted () {
      this.getBrandName()
    },
    data () {
      return {
        templateLang: 'en_US',
        enableRefIdApproach: false,
        refId: '',
        recoveryType: '',
        accountunlocked: false,
        brandDetails: brandDetails,
        brand: '',
        tclink: 'https://www.cargill.com/portal-terms',
        pplink: 'https://www.cargill.com/page/privacy',
        listofsecquestions: [],
        lang: locale.lang,
        lang_obj: locale.lang_obj,
        fetchResponse: '',
        phoneNumber: '',
        countryCode: 1,
        token: '',
        userId: '00ud1f5tz9guPug9Z0h7',
        firstName: '',
        lastName: '',
        loginId: '',
        errorCode: '',
        password: '',
        showPhNoPane: false,
        selectedSecQN: 'disliked_food',
        repeatpassword: '',
        securityImage: '',
        answer: '',
        custom_question: '',
        issuccess: false,
        iserror: false,
        verifycode: '',
        factorId: '',
        enableOTPSend: true,
        error30SecOTP: false,
        phoneNoAlreadySet: false,
        tokenInvalid: false,
        pwdValid: false,
        activateFactorId: '',
        passwordPolicyArray: [],
        currPwdPolicy: {},
        pwdComplexity: {},
        pwdErrorArray: [],
        errorMessages: {},
        userSecQuestion: '',
        codeSent: false,
        user_lang: locale.lang_obj['en_US'],
        minAnswerLength: '',
        stateToken: '',
        secQAVerified: false,
        showResetQA: false,
        loading: true,
        smsFactorId: '',
        emptypasscode: '',
        nofactorpresent: false,
        passwordreset: false,
        regApps: [],
        isServiceAccountGroupMember: false
      }
    },
    components: {
      Spinner
    },
    computed: {
      // var regexStr = '^'+isNumber+isMinLength
      // var pwdRegex = new RegExp(regexStr)
      pwdValidationObj: function() {
        var errors = []
        var minCharRegex = isMinLength.replace('8', this.pwdComplexity.minLength)
        if (this.password.trim().length > 0) {
          if (this.pwdComplexity.minLowerCase > 0 && !this.password.trim().match(new RegExp(islowerCase))) {
            errors.push(this.user_lang.noLowerCase)
          }
          if (this.pwdComplexity.minUpperCase > 0 && !this.password.trim().match(new RegExp(isUpperCase))) {
            errors.push(this.user_lang.noUpperCase)
          }
          if (this.pwdComplexity.minNumber > 0 && !this.password.trim().match(new RegExp(isNumber))) {
            errors.push(this.user_lang.noNumber)
          }
          if (this.pwdComplexity.minSymbol > 0 && !this.password.trim().match(new RegExp(isSpecialChar))) {
            errors.push(this.user_lang.noSpecialCharacter)
          }
          if (!this.password.trim().match(new RegExp(minCharRegex))) {
            errors.push(this.user_lang.notMinLength.replace('$', this.pwdComplexity.minLength))
          }
          if (this.pwdComplexity.excludeAttributes !== undefined && this.pwdComplexity.excludeAttributes.includes('lastName') &&
          this.password.trim().indexOf(this.lastName) !== -1) {
            errors.push(this.user_lang.noLastnameSubstring)
          }
          if (this.pwdComplexity.excludeAttributes !== undefined && this.pwdComplexity.excludeAttributes.includes('firstName') &&
          this.password.trim().indexOf(this.firstName) !== -1) {
            errors.push(this.user_lang.noFirstnameSubstring)
          }
          if (this.pwdComplexity.excludeUsername && this.loginId.indexOf(this.password.trim()) > -1) {
            errors.push(this.user_lang.noUsernameSubstring)
          }
          if (errors.length === 0) {
            this.pwdValid = true
          }
        }
        this.pwdErrorArray = errors
        return errors
      },
      repeatPwdValidationObj: function() {
        var errors = []
        if (this.repeatpassword.trim().length > 0) {
          if (this.password.trim() !== this.repeatpassword.trim()) {
            errors.push(this.user_lang.passwordnotmatching)
          }
        }
        this.pwdErrorArray = errors
        return errors
      }
    },
    methods: {
      getParameterByName: function (name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
        var results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
      },
      keyPressHandler(evt) {
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          return false;
        }
        return true;
      },
      assignUserLang() {
        var self = this
        self.user_lang = self.lang_obj[this.lang]
      },
      goToApp (url) {
        window.open(url, '_blank')
      },
      getPasswordPolicy () {
        var self = this
        self.loading = true
        idmApi.getPasswordPolicy(`${apiUrl}/policies`, self.token).then(function (response) {
          self.passwordPolicyArray = response.data
          if (self.passwordPolicyArray.length === 1) {
            self.currPwdPolicy = response.data.filter(function(i) { if (i.name === 'Default Policy') return i })
          } else {
            self.currPwdPolicy = response.data.filter(function(i) { if (i.name === 'Legacy Policy') return i })
          }
          self.pwdComplexity = self.currPwdPolicy[0].settings.password.complexity
          self.minAnswerLength = self.currPwdPolicy[0].settings.recovery.factors.recovery_question.properties.complexity.minLength
          if (self.currPwdPolicy[0].settings.recovery.factors.recovery_question.status === 'INACTIVE') {
            self.secQAVerified = true
          }
          self.loading = false
        })
      },
      getSecQuestion () {
        var self = this
        self.loading = true
        idmApi.getUserIdByEmail(`${apiUrl}/users/${self.loginId}`, self.token).then(function (response) {
          var ques = response.data.credentials.recovery_question.question
          var fq = self.listofsecquestions.filter(x => x.question.trim() === ques.trim())
          if (fq.length > 0) {
            self.userSecQuestion = fq[0].questionText
          } else {
            self.userSecQuestion = ques
          }
          self.loading = false
        })
      },
      resetPasswordImpl () {
        var self = this
        let data = {
          "credentials": {
            "password": {
              "value": this.password
            },
            "recovery_question": {
              "question": this.selectedSecQN === 'custom' ? this.custom_question : (this.listofsecquestions.filter(x => x.question === this.selectedSecQN)[0]).questionText,
              "answer": this.answer
            }
          }
        }
        idmApi.setUserAccount(`${apiUrl}/users/${self.userId}`, data, self.token).then(function (response) {
          self.loading = false
          if (response.data.status === "ACTIVE") {
            // window.location.href = "http://localhost:8080/Login"
            // storage.set('email', response.data.profile.login ? response.data[0]._embedded.user.profile.login : response.data[0]._embedded.user.profile.email)
            // storage.set('key', base64.encode(self.password))
            self.passwordreset = true
            // okta.oktaSignOut();
            storage.clearAll();
          } else {
           // error handling
          }
        }).catch(error => {
          console.log(error)
          if (error.response && error.response.status === 400 && error.response.data &&
          error.response.data.errorCauses && error.response.data.errorCauses.length && error.response.data.errorCauses[0].errorSummary) {
            window.alert(error.response.data.errorCauses[0].errorSummary)
            self.loading = false
          }
          self.loading = false
        })
      },
      resetPassword () {
        var self = this
        if (self.validateResetPassword() && self.validateCustomSecAnswerWeakness()) {
          self.resetPasswordImpl()
        }
      },
      validateResetPasswordWithoutQA() {
        // const reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/  // '^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$'
        if (this.password.trim() !== '') {
          if (this.password.trim().length) {
            if (this.pwdErrorArray.length === 0) {
              if (this.password.trim() === this.repeatpassword.trim()) {
                this.errorCode = ''
                return true
              } else {
                this.errorCode = 'passwordnotmatching'
                return false
              }
            } else {
              this.errorCode = 'passwordnotvalid'
              return false
            }
          } else {
            this.errorCode = 'passwordlength'
            return false
          }
        } else {
          this.errorCode = 'emptypassword'
          return false
        }
      },
      resetPasswordWithoutQAReset () {
        var self = this
        console.log('test values: ' + self.password + ' ' + self.repeatpassword)
        if (self.validateResetPasswordWithoutQA()) {
          self.resetPasswordWithoutQAResetImpl()
        }
      },
      resetPasswordWithoutQAResetImpl () {
        var self = this
        self.loading = true
        let data = {"stateToken": this.stateToken, "newPassword": self.password.trim()}
        idmApi.resetPassword(`${apiUrl}/credentials/resetpassword`, data).then(function (response) {
          self.loading = false
          if (response.data.status === "SUCCESS") {
            // window.location.href = "http://localhost:8080/Login"
            // storage.set('email', response.data._embedded.user.profile.login ? response.data[0]._embedded.user.profile.login : response.data[0]._embedded.user.profile.email)
            // storage.set('key', base64.encode(self.password))
            self.passwordreset = true
            // okta.oktaSignOut();
            storage.clearAll();
            idmApi.getActiveAppNames(`${apiUrl}/apps/${self.userId}`, self.token).then(function (response) {
              self.regApps = response.data.filter(function (item) {
                if (item.name.toLowerCase() !== 'oidc_client' && !item.visibility.hide.web) {
                  return item
                }
              })
            })
          } else {
             // error handling
          }
        }).catch(error => {
          console.log(error)
          const err = error.response
          if (err && err.status === 403) {
            if (err && err.data.errorCauses && err.data.errorCauses[0].errorSummary.indexOf('current password') > -1) {
              self.errorCode = 'passwordSameasPrev'
            } else if (err && err.data.errorCauses && err.data.errorCauses[0].errorSummary.indexOf('too recently') > -1) {
              self.errorCode = 'passwordusedrecently'
            } else {
              self.errorCode = 'passwordnotmetrequirements'
            }
          }
          self.loading = false
        })
      },
      /* handleRedirect () {
        var self = this
        idmApi.getActiveAppNames(`${apiUrl}/apps/${self.userId}`, self.token).then(function (response) {
          // window.location.href = redirectUrl + '?fromUserReg=true'
          if (response.data.length === 0) { // No application assigned
            // window.location.href = "https://cargillcustomer-qa.oktapreview.com/welcome/" + self.token
          }
          var onecargillappurl = ''
          var urls = response.data.map(function (item) {
            if (item.name !== "bookmark" && item.id !== onecargillappid) { // if assigned to Brazil app
              return item.settings.oauthClient.initiate_login_uri
            }
            if (item.id === onecargillappid) onecargillappurl = item.settings.oauthClient.initiate_login_uri
          })
          if (urls.length || urls[0] !== undefined) window.location.href = urls[0]
          else window.location.href = onecargillappurl
        })
      }, */
      fetchTokenAndInitiate() {
        var self = this
        var actToken = self.getParameterByName('resetPwdToken', document.location.href)
        self.templateLang = self.getParameterByName('lang', document.location.href)
        if (actToken === null || actToken === undefined || actToken.trim() === '') {
          self.setUserLocaleByLanguage(self.templateLang)
          self.enableRefIdApproach = true
          self.loading = false
          setTimeout(function () {
            $('.splash').removeClass('hiddden');
            $('#userRegistration').css('display', 'block');
          }, 500);
        } else {
          self.getTokenAndRedirect(actToken)
        }
      },
      getTokenAndRedirect (token) {
        var self = this
        self.loading = true
        self.token = (token !== null && token !== undefined) ? token.trim() : ''
        self.enableRefIdApproach = false
        self.tokenInvalid = false
        let data = {"recoveryToken": self.token}
        window.history.replaceState(null, "", document.location.href.split("?")[0]);
        idmApi.getUserIdByToken(`${apiUrl}/recovery/token`, data).then(function (response) {
          $('#userRegistration').css('display', 'block');
          self.recoveryType = response.data.recoveryType
          self.setUserLocaleByLanguage(response.data._embedded.user.profile.locale)
          if (self.recoveryType.toLowerCase() === 'unlock' && response.data.status.toLowerCase() === 'success') { // Added for removing Security Question
            self.accountunlocked = true;
            self.loading = false;
            return;
          }
          var responseObj = response.data
          // self.pwdComplexity = responseObj._embedded.policy.complexity
          self.userId = responseObj._embedded.user.id // "00ud1f5tz9guPug9Z0h7"
          self.firstName = responseObj._embedded.user.profile.firstName
          self.lastName = responseObj._embedded.user.profile.lastName
          self.loginId = responseObj._embedded.user.profile.login
          self.getBrandName(self.loginId)
          self.stateToken = responseObj.stateToken
          idmApi.getActiveAppNames(`${apiUrl}/apps/${self.userId}`, self.token).then(function (response) {
            self.regApps = response.data.filter(function (item) {
              if (item.name.toLowerCase() !== 'oidc_client' && !item.visibility.hide.web) {
                return item
              }
            })
          })
          idmApi.getGroupsByUserId(`${apiUrl}/users/${self.userId}/groups`, self.token).then(function (response) {
            self.isServiceAccountGroupMember =
            response.data.filter(x => (x.profile.name.toLowerCase().indexOf('service accounts') > -1 ||
            x.profile.name.toLowerCase().indexOf('brazilian portalapp') > -1 ||
            x.profile.name.toLowerCase().indexOf('cargillonlinefeed') > -1 ||
            x.profile.name.toLowerCase().indexOf('cargillonlinefeedusers') > -1 ||
            x.profile.name.toLowerCase().indexOf('crm velo salesforce') > -1)).length > 0 ? true : false // eslint-disable-line
            idmApi.getUserIdByEmail(`${apiUrl}/users/${self.userId}`, self.token).then(function (response) {
              // self.setUserLocale(response.data.profile.locale)
              var emailDomain = self.loginId.split('@').length > 1 ? self.loginId.split('@')[1] : ''
              if (!self.isServiceAccountGroupMember && internalUserDomains.filter(x => x.toLowerCase().indexOf(emailDomain.toLowerCase()) > -1).length > 0) {
                self.passwordreset = true
              } else if (response.data.credentials.provider.type.toLowerCase() === 'federation' && !self.isServiceAccountGroupMember) {
                self.passwordreset = true
              } else {
                self.getPasswordPolicy()
                self.getSecQuestion()
                self.checkPhoneNumber()
              }
            }).catch(err => {
              self.loading = false;
              console.log("create Insert CF Error: ", err);
            })
          }).catch(err => {
            self.loading = false;
            console.log("create Insert CF Error: ", err);
          })
          // self.loading = false
        }).catch(error => {
          $('#userRegistration').css('display', 'block');
          self.setUserLocaleByLanguage(self.templateLang, false)
          // self.getBrandBg()
          self.getBrandName(self.loginId)
          if (error.toString().toLowerCase().indexOf('network error') > -1) {
            console.log('Network Error. please check your connection')
            self.loading = false
            self.tokenInvalid = true
            self.enableRefIdApproach = false
          } else if (error.response.status === 401 || error.response.status === 403) {
            self.loading = false
            self.tokenInvalid = true
            self.enableRefIdApproach = false
          }
        })
      },
      getBrandBg () {
        var self = this
        console.log(self.brandDetails)
        var brand = self.brandDetails.data.filter(n => n.applicationUrls.indexOf(document.location.host) > -1)
        console.log(brand)
        if (brand.length && brand[0].bgImageLink.trim() !== '') {
          $('.splash').attr("src", brand[0].bgImageLink)
        }
        setTimeout($('.splash').removeClass('hiddden'), 500);
      },
      getBrandName (email) {
        var self = this
        var bd = self.brandDetails.data.filter(n => n.applicationUrls.indexOf(document.location.host) > -1)[0];
        /* if (email.toLowerCase().indexOf('@identity.mycargill.com') > -1 || email.toLowerCase().indexOf('@whitelabel.cargill.com') > -1 || email.toLowerCase().indexOf('@partneridentity.okta-emea.com') > -1) {
          bd = self.brandDetails.data.filter(n => n.brandCode.toLowerCase() === email.substr(2, 3))[0]
          self.brand = bd.brandName
        } else {
          bd = self.brandDetails.data.filter(n => n.brandName.toLowerCase() === 'cargill')[0]
          self.brand = 'Cargill'
        } */
        self.brand = bd.brandName
        self.tclink = bd.termsandconditionslink
        self.pplink = bd.privacypolicylink
        var bgimg = bd.bgImageLink.trim()
        if (bgimg !== '') {
          if (bgimg.indexOf('#') !== 0) {
            $('.splash').attr("src", bgimg)
          } else {
            $('.splash').attr("src", "")
            $('.splash').css("background", bgimg)
          }
        }
        setTimeout($('.splash').removeClass('hiddden'), 500);
        /* if (bd.themeColor.trim() === '') {
          bd.themeColor = '#e7efef'
        }
        if (bd.themeButtonColor.trim() === '') {
          bd.themeButtonColor = var(--theme-primary)
        }
        $('.welcome').css('background', bd.themeColor)
        $('input[type=button], input[type=button]:hover, button, button:hover').css('background-color', bd.themeButtonColor)
        $('input[type=button], input[type=button]:hover, button, button:hover').css('border-color', bd.themeButtonColor)
        $('input[type=button], input[type=button]:hover, button, button:hover').css('color', bd.themeButtonTextColor)
        $('.fa-check-circle').css('color', bd.themeButtonColor) */
        $('.fa-chevron-right').css('color', bd.themeButtonTextColor)
      },
      validateCustomSecAnswerWeakness () {
        var self = this
        if (self.selectedSecQN === 'custom') {
          var questionWordsArray = self.custom_question.trim().toLowerCase().split(' ')
          var answerWordsArray = self.answer.trim().toLowerCase().split(' ')
          var isWeak = questionWordsArray.some(r => answerWordsArray.indexOf(r) >= 0 && r.trim() !== '')
          if (isWeak) {
            this.errorCode = 'securityquestionanswerweak'
            return false
          } else {
            this.errorCode = ''
            return true
          }
        } else {
          this.errorCode = ''
          return true
        }
      },
      validateResetPassword() {
        // const reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/  // '^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$'
        if (this.password.trim() !== '') {
          if (this.password.trim().length) {
            if (this.pwdErrorArray.length === 0) {
              if (this.password.trim() === this.repeatpassword.trim()) {
                if (this.answer.trim().length >= this.minAnswerLength) {
                  if (this.selectedSecQN === 'custom' && this.custom_question.trim() === '') {
                    this.errorCode = 'customQuestionEmpty'
                    return false
                  } else {
                    if (this.selectedSecQN === 'custom' && this.custom_question.trim().toLowerCase().indexOf(this.answer.trim().toLowerCase()) > -1) {
                      this.errorCode = 'customQAsame'
                      return false
                    } else {
                      this.errorCode = ''
                      return true
                    }
                  }
                } else {
                  this.user_lang.answerlength = this.user_lang.answerlength.replace('$', this.minAnswerLength)
                  this.errorCode = 'answerlength'
                  return false
                }
              } else {
                this.errorCode = 'passwordnotmatching'
                return false
              }
            } else {
              this.errorCode = 'passwordnotvalid'
              return false
            }
          } else {
            this.errorCode = 'passwordlength'
            return false
          }
        } else {
          this.errorCode = 'emptypassword'
          return false
        }
      },
      forgotSQA () {
        var self = this
        self.error30SecOTP = false
        self.loading = true
        self.emptypasscode = false
        self.nofactorpresent = false
        let data = { "passCode": "" }
        if (self.smsFactorId !== '' && self.smsFactorId !== undefined) {
          idmApi.sendCode(`${apiUrl}/users/${self.userId}/factors/${self.smsFactorId}/verify`, data, self.token).then(function (response) {
            self.issuccess = true
            self.codeSent = true
            self.loading = false
          }).catch(error => {
            console.log(error)
            self.loading = false
            if (error.response.status === 429) {
              self.error30SecOTP = true
            }
          })
        } else {
          self.loading = false
          self.nofactorpresent = true
        }
      },
      goBack () {
        this.codeSent = false;
      },
      verifySMS () {
        var self = this
        self.showResetQA = true
        self.codeSent = false
      },
      verifyResendCode () {
        var self = this
        self.emptypasscode = false
        if (self.verifycode.trim().length !== 0) {
          let data = { "passCode": this.verifycode.trim() }
          idmApi.sendCode(`${apiUrl}/users/${self.userId}/factors/${self.smsFactorId}/verify`, data, self.token).then(function (response) {
            if (response.data.factorResult === 'SUCCESS') {
              self.showResetQA = true
              self.codeSent = false
              self.issuccess = true
              self.answer = ''
            }
          }).catch(error => {
            console.log(error)
            if (error.response.status === 403) {
              self.iserror = true
            }
            self.loading = false
          })
        } else {
          self.emptypasscode = true
        }
      },
      checkPhoneNumber () {
        var self = this
        idmApi.getFactorByUserId(`${apiUrl}/users/${self.userId}/factors`, self.token).then(function (response) {
          if (response.data.length > 0) {
            self.smsFactorId = response.data[0].id
          }
        })
      },
      validateSecQA () {
        if (this.answer.trim().length >= this.minAnswerLength) {
          if (this.custom_question.trim() !== this.answer.trim()) {
            this.errorCode = ''
            return true
          } else {
            this.errorCode = 'customQAsame'
            return false
          }
        } else {
          this.user_lang.answerlength = this.user_lang.answerlength.replace('$', this.minAnswerLength)
          this.errorCode = 'answerlength'
          return false
        }
      },
      resetPasswordCheckSecQA () {
        var self = this
        self.nofactorpresent = false
        if (this.validateSecQA()) {
          let data = {"stateToken": this.stateToken, "answer": this.answer.trim()}
          idmApi.verifySecurityAnswer(`${apiUrl}/recovery/answer`, data).then(function (response) {
            if (response.data.recoveryType === 'UNLOCK') {
              self.accountunlocked = true
            } else {
              self.secQAVerified = true
            }
          }).catch(error => {
            console.log(error)
            self.errorCode = 'answerWrong';
            this.loading = false
          })
        }
      },
      changeUserLang: function(e) {
        locale.lang = e.target.value
        this.user_lang = this.lang_obj[e.target.value]
        EventBus.$emit('lang', e.target.value)
      },
      resetSecQA () {
        this.resetSecQA = false
        this.codeSent = false
        this.secQAVerified = true
        this.showResetQA = false
      },
      setUserLocale (loginId) {
        var self = this
        self.loading = true
        idmApi.getUserIdByEmail(`${apiUrl}/users/${loginId}`, self.token).then(function (response) {
          self.loading = false
          var profileLang = response.data.profile.locale
          if (profileLang !== undefined) {
            // to test change in language setting to vietnamese in okta it is spanish
            if (profileLang !== null && profileLang.trim() !== '') {
              Object.keys(locale.lang_obj).forEach(function(i) {
                if (profileLang.toLowerCase().indexOf(i.toLowerCase()) > -1) {
                  locale.lang = i
                  EventBus.$emit('lang', i)
                }
              })
            } else {
              locale.lang = 'en_US'
              EventBus.$emit('lang', 'en_US')
            }
            /* idmApi.getListOfSecurityQuestionsByLanguage(`${apiUrl}/${locale.lang}/securityquestions`, self.token).then(function (response) {
              self.listofsecquestions = response.data
            }) */
          } else {
            locale.lang = 'en_US'
            storage.set('user-lang', 'en_US')
            EventBus.$emit('lang', 'en_US')
            /* idmApi.getListOfSecurityQuestionsByLanguage(`${apiUrl}/${locale.lang}/securityquestions`, self.token).then(function (response) {
              self.listofsecquestions = response.data
            }) */
          }
        })
      },
      setUserLocaleByLanguage (val, istokenvalid) {
        var self = this
        // idmApi.getUserIdByEmail(`${apiUrl}/users/${loginId}`).then(function (response) {
        self.loading = false
        var profileLang = val
        if (profileLang !== undefined) {
          // to test change in language setting to vietnamese in okta it is spanish
          if (profileLang !== null && profileLang.trim() !== '') {
            Object.keys(locale.lang_obj).forEach(function(i) {
              if (profileLang.toLowerCase().indexOf(i.toLowerCase()) > -1) {
                locale.lang = i
                EventBus.$emit('lang', i)
              }
            })
          } else {
            locale.lang = 'en_US'
            EventBus.$emit('lang', 'en_US')
          }
          if (istokenvalid !== false) {
            /* idmApi.getListOfSecurityQuestionsByLanguage(`${apiUrl}/${locale.lang}/securityquestions`, self.token).then(function (response) {
              self.listofsecquestions = response.data
            }) */
          }
        } else {
          locale.lang = 'en_US'
          storage.set('user-lang', 'en_US')
          EventBus.$emit('lang', 'en_US')
          if (istokenvalid !== false) {
            /* idmApi.getListOfSecurityQuestionsByLanguage(`${apiUrl}/${locale.lang}/securityquestions`, self.token).then(function (response) {
              self.listofsecquestions = response.data
            }) */
          }
        }
        // })
      },
      resetSecQAPassword () {
        var self = this
        let data = {
          "credentials": {
            "password": {
              "value": this.password
            },
            "recovery_question": {
              "question": this.selectedSecQN === 'custom' ? this.custom_question : (this.listofsecquestions.filter(x => x.question === this.selectedSecQN)[0]).questionText,
              "answer": this.answer
            }
          }
        }
        idmApi.setUserAccount(`${apiUrl}/users/${self.userId}`, data, self.token).then(function (response) {
        })
      }
    }
  }
</script>
<style scoped>
.hiddden{visibility:hidden}
.custom-select {
    display: inline-block;
    max-width: 100%;
    height: calc(2.50rem + 2px);
    padding: 0.375rem 1.75rem 0.375rem 0.75rem;
    line-height: 1.25;
    background-color: #ececeb;
    vertical-align: middle;
    background-size: 8px 10px;
    border: 1px solid #00524A;
    border-radius: 0;
    -moz-appearance: none;
    -webkit-appearance: none;
}
.card-block {
  background: var(--theme-primary);
  border: 1px solid #00524A;
}
/*input{background: #fff;}*/
input, select{height: 30px;color:#333;margin-top:7px;}
.password-rule{color: #666;font-size: 12px;display: block;line-height: 16px;}
.setup-section{background:#fff;
/*border-radius:8px;border: 1px solid #ccc; margin-left: auto;margin-right: auto;text-align: left;padding-bottom: 20px;margin-bottom: 20px;font-size:14px;*/
font-size:13px;}
label > input{ /* HIDE RADIO */
  visibility: hidden; /* Makes input not-clickable */
  position: absolute; /* Remove input from document flow */
}
label > input + img{ /* IMAGE STYLES */
  cursor:pointer;
  border:2px solid #ddd;
}
label > input:checked + img{ /* (RADIO CHECKED) IMAGE STYLES */
  border:2px solid #333;
  border-radius:0px;
}
.exclamatory-error-icon{color:#e34843;background:#ffffff;border-radius: 20px; width: 16px; height: 16px; display: block;
    margin: 5px 3px;
    padding-left: 5px;
    line-height: 16px;
    font-weight: bold;}
.checked-icon{background: #333;padding: 3px;border-radius:3px;}
.checked-icon-container{position: absolute; margin:10px;}
.infobox-before-common, .infobox::before, .infobox-md::before, .infobox-compact::before {
  position: absolute;
  top: -1px;
  bottom: -1px;
  left: -1px;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  content: '';
}
/* line 18, target/sass/courage/infobox/_all.scss */
.infobox {
  position: relative;
  min-height: 18px;
  padding: 12px 18px 12px 48px !important;
  -webkit-hyphens: auto;
      -ms-hyphens: auto;
          hyphens: auto;
  word-break: break-word;
}
/* line 25, target/sass/courage/infobox/_all.scss */
.infobox::before {
  width: 36px;
  background-color: #007dc1;
}
/* line 31, target/sass/courage/infobox/_all.scss */
.infobox.infobox-no-icon {
  padding-left: 24px !important;
}
/* line 34, target/sass/courage/infobox/_all.scss */
.infobox.infobox-no-icon::before {
  display: none;
}
/* line 39, target/sass/courage/infobox/_all.scss */
.infobox > .icon {
  position: absolute;
  top: 13px;
  left: 9px;
}
/* line 45, target/sass/courage/infobox/_all.scss */
.infobox a {
  line-height: 18px;
}
/* line 49, target/sass/courage/infobox/_all.scss */
.infobox ul {
  margin-right: 0;
}
/* line 54, target/sass/courage/infobox/_all.scss */
.infobox .link-button {
  line-height: 28px;
}
/* line 58, target/sass/courage/infobox/_all.scss */
.infobox + .infobox,
.infobox + h2 {
  margin-top: 18px;
}
/* line 63, target/sass/courage/infobox/_all.scss */
.infobox .two_col_left {
  width: 80%;
}
/* line 67, target/sass/courage/infobox/_all.scss */
.infobox .two_col_right {
  width: 19%;
  margin-left: 1%;
  padding-left: 0;
}
/* line 72, target/sass/courage/infobox/_all.scss */
.infobox .two_col_right .button-primary {
  width: 100% !important;
  float: right;
  box-sizing: border-box;
}
/* line 80, target/sass/courage/infobox/_all.scss */
.infobox[style='display: none;'] + .infobox,
.infobox[style='display:none;'] + .infobox {
  margin-top: 0;
}
/* line 85, target/sass/courage/infobox/_all.scss */
.infobox h2,
.infobox h3,
.infobox h2 *,
.infobox h3 * {
  margin: 0;
  padding: 0;
  font-size: 13px;
  font-weight: bold;
  line-height: 18px;
}
/* line 96, target/sass/courage/infobox/_all.scss */
.infobox h2 span,
.infobox h3 span {
  color: #5e5e5e;
}
/* line 101, target/sass/courage/infobox/_all.scss */
.infobox h2 + *,
.infobox h3 + *,
.infobox p + *,
.infobox ul + *,
.infobox ol + *,
.infobox li + * {
  margin-top: 9px;
}
/* line 116, target/sass/courage/infobox/_all.scss */
.infobox,
.infobox-md {
  border: 1px solid #ddd;
  border-radius: 3px;
  background-color: #fbfbfb;
}
/* line 124, target/sass/courage/infobox/_all.scss */
.infobox-md {
  min-height: 18px;
  padding: 24px 24px 24px 70px !important;
}
/* line 128, target/sass/courage/infobox/_all.scss */
.infobox-md h2,
.infobox-md h3 {
  font-size: 15px;
}
/* line 132, target/sass/courage/infobox/_all.scss */
.infobox-md h2 *,
.infobox-md h3 * {
  margin: 0;
  line-height: 18px;
}
/* line 138, target/sass/courage/infobox/_all.scss */
.infobox-md::before {
  width: 48px;
}
/* line 143, target/sass/courage/infobox/_all.scss */
.infobox-md > .icon {
  top: 20px;
  left: 11px;
}
/* line 148, target/sass/courage/infobox/_all.scss */
.infobox-md + .button-bar.button-bar-attached {
  width: auto;
  padding-left: 60px;
  float: none;
}
/* line 153, target/sass/courage/infobox/_all.scss */
.infobox-md + .button-bar.button-bar-attached.button-bar-l-height {
  line-height: 32px;
}
/* line 163, target/sass/courage/infobox/_all.scss */
.infobox-compact {
  min-height: 16px;
  padding: 9px 9px 9px 40px !important;
  border-width: 1px;
  border-style: solid;
  border-radius: 3px;
  border-color: #ddd;
  background-color: #fbfbfb;
}
/* line 172, target/sass/courage/infobox/_all.scss */
.infobox-compact a,
.infobox-compact p,
.infobox-compact li {
  line-height: 16px;
}
/* line 178, target/sass/courage/infobox/_all.scss */
.infobox-compact h2 + *,
.infobox-compact h3 + *,
.infobox-compact p + *,
.infobox-compact ul + *,
.infobox-compact ol + *,
.infobox-compact li + * {
  margin-top: 5px;
}
/* line 187, target/sass/courage/infobox/_all.scss */
.infobox-compact::before {
  width: 30px;
}
/* line 192, target/sass/courage/infobox/_all.scss */
.infobox-compact + p {
  margin-top: 9px;
}
/* line 196, target/sass/courage/infobox/_all.scss */
.infobox-compact > .icon {
  top: 9px;
  left: 6px;
}
/* line 205, target/sass/courage/infobox/_all.scss */
.infobox-xl {
  min-height: 18px;
  padding: 26px 36px 26px 108px !important;
}
/* line 209, target/sass/courage/infobox/_all.scss */
.infobox-xl::before {
  width: 84px;
}
/* line 213, target/sass/courage/infobox/_all.scss */
.infobox-xl > .icon {
  top: 22px;
  left: 18px;
}
/* line 218, target/sass/courage/infobox/_all.scss */
.infobox-xl p,
.infobox-xl ul {
  width: 75%;
  margin-top: 20px;
}
/* line 224, target/sass/courage/infobox/_all.scss */
.infobox-xl p,
.infobox-xl li {
  font-size: 14px;
  line-height: 20px;
}
/* line 230, target/sass/courage/infobox/_all.scss */
.infobox-xl h2,
.infobox-xl h3 {
  font-size: 18px;
}
/* line 234, target/sass/courage/infobox/_all.scss */
.infobox-xl h2 *,
.infobox-xl h3 * {
  margin: 0;
  line-height: 18px;
}
/* line 245, target/sass/courage/infobox/_all.scss */
.infobox-teach h2,
.infobox-teach h3 {
  color: #835ab1;
  font-weight: 200;
}
/* line 251, target/sass/courage/infobox/_all.scss */
.infobox-teach.infobox-dismiss .button-teach {
  margin-top: 20px;
  float: right;
}
/* line 259, target/sass/courage/infobox/_all.scss */
.infobox-dismiss {
  padding-right: 30px !important;
}
/* line 263, target/sass/courage/infobox/_all.scss */
.infobox-dismiss-link {
  display: block;
  position: absolute;
  top: 10px;
  right: 8px;
  color: #5e5e5e;
  line-height: 14px;
  cursor: pointer;
}
/* line 273, target/sass/courage/infobox/_all.scss */
.infobox-dismiss-link:hover {
  text-decoration: none;
}
/* line 277, target/sass/courage/infobox/_all.scss */
.help-wrap .infobox.infobox-dismiss .infobox-dismiss-link {
  top: 0;
  right: 0;
}
/* line 283, target/sass/courage/infobox/_all.scss */
.infobox-dismiss-hide {
  display: none !important;
}
/* line 292, target/sass/courage/infobox/_all.scss */
.infobox-confirm {
  position: absolute !important;
  top: 20px;
  left: 50%;
  width: 240px;
  margin-left: -154px;
  box-shadow: 0 2px 0 rgba(160, 160, 160, 0.1);
  z-index: 10;
}
/* line 302, target/sass/courage/infobox/_all.scss */
.infobox-confirm-fixed {
  position: fixed !important;
  top: 106px;
}
/* line 306, target/sass/courage/infobox/_all.scss */
.infobox-confirm-fixed .infobox-dismiss-link {
  top: 14px;
  right: 14px;
}
/* line 318, target/sass/courage/infobox/_all.scss */
.infobox.infobox-subtle.infobox-success::before,
.help-wrap .infobox.infobox-success::before,
.infobox-success::before {
  background-color: #4cbf9c;
}
/* line 324, target/sass/courage/infobox/_all.scss */
.infobox.infobox-subtle.infobox-warning::before,
.help-wrap .infobox.infobox-warning::before,
.infobox-warning::before {
  background-color: #f1d10d;
}
/* line 330, target/sass/courage/infobox/_all.scss */
.infobox.infobox-subtle.infobox-error::before,
.help-wrap .infobox.infobox-error::before,
.infobox-error::before {
  background-color: #e34843;
}
/* line 336, target/sass/courage/infobox/_all.scss */
.infobox.infobox-subtle.infobox-tip::before,
.infobox.infobox-subtle.infobox-teach::before,
.help-wrap .infobox.infobox-tip::before,
.help-wrap .infobox.infobox-teach::before,
.infobox-tip::before,
.infobox-teach::before {
  background-color: #835ab1;
}
/* line 346, target/sass/courage/infobox/_all.scss */
.infobox-warning .icon.processing-16 {
  width: 16px;
  height: 16px;
  background: url("/assets/img/ui/indicators/ajax-loader-processing-16.995b6ac81af8ed76a8ade6aba2f6d4d1.gif") no-repeat 0 0 transparent;
}
/* line 352, target/sass/courage/infobox/_all.scss */
.infobox-warning .icon.processing-24 {
  width: 24px;
  height: 24px;
  background: url("/assets/img/ui/indicators/ajax-loader-processing-24.2564f2a8efed77df6c170335ff3001ef.gif") no-repeat 0 0 transparent;
}
/* line 358, target/sass/courage/infobox/_all.scss */
.infobox-error .icon.processing-16 {
  width: 16px;
  height: 16px;
  background: url("/assets/img/icons/16x16/error-01.fa55d715ffe62d95fb0eded26d323a55.png") no-repeat 0 0 transparent;
}
/* line 365, target/sass/courage/infobox/_all.scss */
.infobox + .button-bar,
.infobox + .button-bar-small {
  border-top: 0;
}
/* line 370, target/sass/courage/infobox/_all.scss */
.infobox-no-border + .button-bar,
.infobox-no-border + .button-bar-small {
  border-top: 1px solid #dadada;
}
/* line 376, target/sass/courage/infobox/_all.scss */
.infobox-no-border {
  border: none !important;
}
/* line 380, target/sass/courage/infobox/_all.scss */
.infobox-text {
  padding: 0;
}
/* line 384, target/sass/courage/infobox/_all.scss */
.infobox-header {
  font-weight: bold;
}
/* line 388, target/sass/courage/infobox/_all.scss */
.infobox-divider {
  border-bottom: 1px dotted #ddd;
}
/* line 396, target/sass/courage/infobox/_all.scss */
.edit-form .infobox,
.read-only-form .infobox,
.ajax-form-editor .infobox,
.form-content-wrap .infobox,
.o-form .infobox,
.m-form .infobox,
.v-form .infobox,
.modal-content-wrap .infobox {
  background-color: #fff;
}
/* line 407, target/sass/courage/infobox/_all.scss */
.infobox.infobox-subtle,
.help-wrap .infobox {
  padding: 0 0 0 18px !important;
  border: 0;
  background: transparent;
}
/* line 413, target/sass/courage/infobox/_all.scss */
.infobox.infobox-subtle::before,
.help-wrap .infobox::before {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 6px;
  border-radius: 0;
  background-color: #007dc1;
  content: '';
}
/* line 424, target/sass/courage/infobox/_all.scss */
.infobox.infobox-subtle .icon,
.help-wrap .infobox .icon {
  display: none;
}
/* line 4, target/sass/modules/infobox/_overrides.scss */
.infobox-teach + .ui-tabs {
  margin-top: 18px;
}
.reg-nav{color:#DBAA00 !important;
border-top: solid 6px #DBAA00;padding-top:10px;}
.title-bar{margin-right: -15px;
    margin-left: -15px;
    margin-top: -5px;}
input, select{
    border: 2px solid #dde3e6!important;
    /* max-width: 400px !important; */
    display: block !important;
    border-radius: 0px !important;
    min-height: 35px;
    padding-left: 5px;
}
input[type=button]:hover, button:hover {
    background-color: var(--theme-primary) !important;
    border: 1px solid var(--theme-primary) !important;
	/* color: #fff !important; */
	border-radius: 0px !important;
}
input[type=button], button
 {  background-color: var(--theme-primary) !important;
    border-color: var(--theme-primary) !important;
	/* color: #fff !important; */
	border-radius: 0px !important;
}
.create-acc{
margin: auto;
border: 1px solid #ccc;
border-radius: 3px;
color:var(--regpwd-secondarytextcolor);
margin-bottom: 20px;
height: 34px;
padding-left: 20px;
padding-right: 20px;
margin-top: 20px;
font-size: 14px;
padding: 4px 15px;
float: right;
}
.pwderror{display: block;
    background: #474c55;
    padding-left: 10px;
    color: #ffffff;
    border-bottom: 1px solid #eaeaea;
    max-width: 100%;}
.forgot-link{
    text-decoration: underline;
    margin-top: 5px;
    display: block;
    cursor: pointer;
}
#userRegistration{
max-width: 500px;
    margin: auto;
    margin-top: 100px;
	 margin-bottom: 100px;
}
.bg{
    position: absolute;
    width: 100%;
    height: 100%;
	}
.splash{
position: absolute;
    top: 0px;
    width: 100%;
    height: 100%;
    z-index: -1;
	object-fit: cover;}
.regapps{
max-width: 160px;
width:100px;
padding: 5px;
margin: 15px;
cursor: pointer;
text-align: center;
display: inline-block;
vertical-align: top;
}
.icon-wrap{border: 1px solid #acacac;width: 140px;
border-radius: 3px;
    height: 60px;
    background: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#f4f4f4));    vertical-align: middle;
    display: table-cell;}
.errorwrapper{position: absolute;z-index: 999999999999999;width: 100%;padding-right: 30px;}
</style>



// WEBPACK FOOTER //
// ResetPassword.vue?b2cb7da8